module.exports = __webpack_public_path__ + "img/scene3-0.2dab1e19.jpg";